// src/components/UI/UserCard/hooks/useUserRoles.js

import { useMemo } from 'react';
import { ROLE_CONFIG } from '../constants/cardConstants';

export const useUserRoles = (user) => {
  return useMemo(() => {
    if (!user) return [];

    const roles = [];
    const hasSpecialRole = user.is_superuser || user.is_staff ||
                          user.is_librarian || user.is_donor;

    // Легенда первого дня (только если нет других ролей)
    if (user.id <= 30 && !hasSpecialRole) {
      roles.push({ type: 'legend', ...ROLE_CONFIG.legend });
    }
    if (user.is_superuser) {
      roles.push({ type: 'superuser', ...ROLE_CONFIG.superuser });
    }
    if (user.is_staff && !user.is_superuser) {
      roles.push({ type: 'moderator', ...ROLE_CONFIG.moderator });
    }
    if (user.is_librarian) {
      roles.push({ type: 'librarian', ...ROLE_CONFIG.librarian });
    }
    if (user.is_donor) {
      roles.push({ type: 'donor', ...ROLE_CONFIG.donor });
    }

    return roles.sort((a, b) => b.priority - a.priority);
  }, [user]);
};